/* RESPONSIBLE TEAM: team-conversational-knowledge */
import ApplicationAdapter from '../application';

export default class TaskSuggestionAdapter extends ApplicationAdapter {
  pathForType(): string {
    return 'ai_insights/task_suggestions';
  }

  // Override buildURL to ensure we use the correct path
  buildURL(_modelName: any, _id?: string | number, _snapshot?: any, _requestType?: string): string {
    let baseUrl = '/ember/ai_insights/task_suggestions';
    if (_id) {
      return `${baseUrl}/${_id}`;
    }
    return baseUrl;
  }
}
